import { interval, lastValueFrom, takeWhile } from 'rxjs';

export class WaitUtil {
  static async waitUntilSet(set: () => unknown) {
    return lastValueFrom(interval(50).pipe(takeWhile(() => set() == null, true)));
  }
}
